import Vue from 'vue'

if (document.querySelector('#activities-page')) {
  Vue.component('activities-search', require('./Activities/Index.vue').default)
  new Vue({ el: '#activities-page' })
}

if (document.querySelector('#travel-page')) {
  Vue.component('travel-search', require('./Travel/Index.vue').default)
  new Vue({ el: '#travel-page' })
}

if (document.querySelector('#hotels-page')) {
  Vue.component('hotels-search', require('./Hotels/Index.vue').default)
  new Vue({ el: '#hotels-page' })
}

if (document.querySelector('#partner-detail-page')) {
  Vue.component('partner-detail', require('./Partner/Detail.vue').default)
  new Vue({ el: '#partner-detail-page' })
}

if (document.querySelector('#partner-reviews-feed')) {
  Vue.component('spot-reviews-feed', require('@/components/Spots/Feed/Index').default)
  new Vue({
    name: "Partner Reviews Feed",
    el: "#partner-reviews-feed",
  })
}

if (document.querySelector('#partner-leave-a-review')) {
  Vue.component('leave-a-review', require('@/components/Reviews/Create').default)
  new Vue({
    name: "Partner Leave a Review",
    el: "#partner-leave-a-review",
  })
}
